<template>
  <div class="sm:col-span-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">

    <InputLabeled id="next_rentAmount" inputMode="decimal" label="Kaltmiete" cols="sm:col-span-3" :has-euro-sign="true" placeholder="500"/>
    <InputLabeled id="next_depositAmount" inputMode="decimal" label="Kautionssumme" cols="sm:col-span-3" :has-euro-sign="true" placeholder="1000"/>

    <p v-if="tenant.isReservation" class="block text-sm font-medium text-gray-700 sm:col-span-6"> Die Reservierung ist für Sie kostenlos. Bei der
      Umwandlung der Reservierung in eine aktive Bürgschaft
      würden Sie folgenden Beitrag zahlen:</p>
    <div class="flex flex-col items-end sm:col-span-6">
      <div class="text-sm font-medium text-gray-700">monatlicher Beitrag:
        <span class="ml-1 text-xl text-green-500"> {{ monthlyRateString }}</span>
      </div>
      <div class="text-sm font-medium text-gray-700"> (Das entspricht jährlich:
        <span class="ml-1"> {{ yearlyRateString }}</span>)
      </div>
    </div>

  </div>
</template>

<script setup>

import InputLabeled from "./InputLabeled";
import {useTenantStore} from "../stores/tenant";
import { computed } from "vue";
import {watch} from "vue";

const monthlyRateString = computed(() => tenant.monthlyRateString);
const yearlyRateString = computed(() => tenant.yearlyRateString);

const tenant = useTenantStore();

// watch on change of rent or deposit amount and validate both fields (deposit and rent)
watch([() => tenant.formValues.next_rentAmount, () => tenant.formValues.next_depositAmount], () => {
  if (tenant.formValues.next_rentAmount !== '') {
    tenant.validateField('next_rentAmount', tenant.formValues.next_rentAmount);
  }
  if (tenant.formValues.next_depositAmount !== '') {
    tenant.validateField('next_depositAmount', tenant.formValues.next_depositAmount);
  }
}, { immediate: true });

</script>
